import { useEffect, useState } from "react"
import Switch from 'react-switch'
import axios from '../../../plugins/axios'
import { useTranslation } from 'react-i18next';
import Toast from "../../../plugins/useToast";
import Dropdown from "./Dropdown"

const BarcodeLabel = () => {
    const { t } = useTranslation();
    const [format, setFormat] = useState('NUMBER')
    const [unit, setUnit] = useState({ label: '1', value: 1 })

    const formatOptions = [
        { value: 'NUMBER', label: t('admin.BarcodeLabel.Number')},
        { value: 'NUMBER_AND_STRING', label: t('admin.BarcodeLabel.NumberString')},
    ]
    
    const unitArr = Array.from({ length: 40 }, (_, i) => i + 1).map(num => ({ label: num.toString(), value: num }))

    const [dropdownStates, setDropdownStates] = useState({
        unit: false,
    });

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    // 데이터 저장
    const saveData = async () => {
        try {            
            const payload =  {
                "format": format,
                "length": unit.value
            }
            const res = await axios.put('/system/barcode/settings', payload);            
            if(res.code != 200) throw res;
            
            Toast({ isSuccess: true, msg: t('admin.BarcodeLabel.SettingsSaved') });

        } catch (err) {
            console.warn(err)
        }
    }

    // 현재 설정값 가져오기
    const getBarcodeOption = async() => {
        try{
            const res = await axios.get('/system/barcode/settings');
            setFormat(res.data.format);
            setUnit({ label: res.data.length, value: res.data.length });
        }
        catch(err){
            console.warn(err);
        }
    }    

    useEffect(() => {
        getBarcodeOption();
    }, [])    

    return (
        <div className="">
            <div className="flex mb-10">
                <div className="">
                    <div className="admin-title">{t('admin.BarcodeLabel.Title')}</div>
                    <div className="text-[#ABAEB2]">{t('admin.BarcodeLabel.SubTitle')}</div>
                </div>
                <div className="admin-normal-btn save ml-auto w-[100px] text-white" onClick={() => { saveData() }}>{t('admin.BarcodeLabel.Save')}</div>
            </div>
            <div className="flex gap-10">
                <div className="">
                    <div className="font-light text-[#E1E4E5] mb-3">{t('admin.BarcodeLabel.LabelFormat')}</div>
                    <div className="bg-[#323238] p-5 rounded-lg w-[600px] flex flex-col text-white">    
                        <div className="flex items-center mb-[20px]">
                            <div className="w-[180px] text-[#CBCED1] font-light" style={{ fontSize: 14 }}>{t('admin.BarcodeLabel.LabelFormat')}</div>
                            <div className="flex flex-1 justify-start items-center gap-[20px]">
                                {
                                    formatOptions.map((option) => (
                                        <label key={`lang-option-${option.value}`} className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={format === option.value}
                                                onChange={() => setFormat(option.value)}
                                            />
                                            <span className="font-light" style={{ paddingLeft: 32, fontSize: 16 }}>{option.label}</span>
                                        </label>
                                    ))
                                }
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-[180px] text-[#CBCED1] font-light" style={{ fontSize: 14 }}>{t('admin.BarcodeLabel.LabelLength')}</div>
                            <div className="flex flex-1 justify-start items-center gap-[20px]">
                                <Dropdown
                                    customWidth={380}
                                    type={'barcode-label-unit'}
                                    isShow={dropdownStates.unit}
                                    value={unit}
                                    valueArr={unitArr}
                                    handleClick={(val) => { handleClickDropdown('unit', val) }}
                                    handleValueClick={(val) => { setUnit(val) }}
                                />
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
       </div>
    )
}

export default BarcodeLabel